import DriveIcon from '../../../../../presentational/icons/DriveIcon';
import React, { FunctionComponent } from 'react';
import useTheme from '@material-ui/core/styles/useTheme';
import { ISpcTheme } from '../../../../../../../common/theme/ISpcTheme';
import HelmetIcon from '../../../../../presentational/icons/HelmetIcon';
import NewDriveIcon from '../../../../../presentational/icons/NewDriveIcon';

const TestDriveIcon: FunctionComponent = () => {
  const {
    spc: {
      configuratorSummary: { newTestDriveIcon, helmetTestDriveIcon },
    },
  } = useTheme<ISpcTheme>();

  if (helmetTestDriveIcon) {
    return <HelmetIcon />;
  }

  if (newTestDriveIcon) {
    return <NewDriveIcon />;
  }

  return <DriveIcon />;
};

export default TestDriveIcon;
